<template>
    <div>
        <card-header title="Reflections" icon="fa-flag-swallowtail"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Pending Review" icon="fa-clock" :badge="milestones.length"/>

                <card-list-item
                    v-for="milestone in milestones"
                    :key="milestone.id"
                    @click="$openCard('milestone-detail', {milestoneId: milestone.id}, card)"
                    :class="{'active': child && child.definition.component === 'milestone-detail' && child.props.milestoneId == milestone.id}"
                >
                    <template v-slot:icon><i class="far fa-flag-swallowtail fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">{{ milestone.course_title }}</div>
                        <div class="tile-title">{{ milestone.first_name }} {{ milestone.last_name }}</div>
                        <div class="meta mt-1">
                            Milestone {{ milestone.milestone_number }} of {{ milestone.total_milestones }}
                            <span class="ml-2">{{ milestone.submitted_at | moment('MMMM Do, h:mm A') }}</span>
                        </div>
                    </template>
                </card-list-item>

                <div v-if="milestones.length === 0" class="has-text-centered py-6 has-text-grey">
                    <i class="far fa-check-circle fa-3x mb-3"></i>
                    <p>No pending reflections</p>
                </div>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import {client as http} from "@/http_client";
    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {SubheaderListItem, CardListItem, CardHeader, CardBody, CardList},
        props: ['card', 'child'],
        data() {
            return {
                milestones: []
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['getMilestonesCount']),
            load: function() {
                http.get('/milestones', {force: true}).then(response => {
                    this.milestones = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading milestones:', err);
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.getMilestonesCount();
                this.load();
            }
        },
        mounted: function() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
